import axios from "axios";
import React, { useEffect, useState } from "react";

import MarketPlaceTab from "./MarketPlaceTab";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const MarketMap = () => {
  const [loading, setLoading] = useState(true);
  const [data, setMarketplace] = useState([]);

  useEffect(() => {
    axios.get("/api/user/marketplace/all").then((res) => {
      if (res.status === 200) {
        setMarketplace(res.data.data);
        setLoading(false);
      }
    });
  }, []);

  return (
    <>
      {loading ? (
        <SkeletonTheme baseColor="#202020" highlightColor="#444">
          {[...Array(4)].map((x, i) => (
            <div className="row">
              <>
                <div className="col-md-6 col-sm-6 mb-3">
                  <div className="rounded">
                    <div className="bg-dark py-3 px-2 text-center">
                      <Skeleton width="100%" height={250} />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-md-6">
                  <div className="rounded">
                    <div className="bg-dark py-3 px-2">
                      <Skeleton width="100%" height={70} />
                      <Skeleton width="50%" height={50} />
                      <br />
                      <div className="row">
                        <div className="col-md-2">
                          <Skeleton circle height="60px" width="60px" />
                        </div>
                        <div className="col-md-10">
                          <Skeleton width="100%" className="" height={55} />
                        </div>
                      </div>

                      <Skeleton width="100%" className="" height={35} />
                    </div>
                  </div>
                </div>
              </>
            </div>
          ))}
        </SkeletonTheme>
      ) : (
        data.map((u) => <MarketPlaceTab key={u.id} user={u} />)
      )}
    </>
  );
};

export default MarketMap;
